import React, { Component, useState, useEffect, useRef } from 'react';
import '../../../../Utility/Public/css/common.scss';
import '../Assets/css/homedoc.scss';
import '../Assets/css/homeresponsivedoc.scss';
import CustomInput from '../../../../Utility/Components/CustomInput';
import ErrorBoundary from '../../../../Utility/Components/ErrorBoundary';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import CommonDateTimePicker from '../../../../Utility/Components/CommonDateTimePicker';
import AutosuggestComponent from '../../../../Utility/Components/AutosuggestComponent';
import { connect } from 'react-redux';
import { withRouter, useParams } from 'react-router-dom';
import moment from 'moment';
import { destinationList, filterPanelList, getTourLocationList } from '../Controller/HomeController';
import { loaderStateTrue, loaderStateFalse, selectChooseBranch, userSearchData, roleWisePermission, userSearchDataError, trendingDestination, hotelGroupPackageSelectedData, groupTourPackageSearchData } from '../../../../Actions/AllAction';
import { setToken, setUserCredentials, logOutApp } from '../../../../../src/GlobalModules/Login/Actions/LoginAction';
import Select, { components } from "react-select";
import Utility from '../../../../Utility/Utility';
import { useHistory, useLocation } from 'react-router-dom';
import {
    Hotel,
    House,
    UsersRound,
    Plane,
    TrainFront,
    BusFront,
    CarFront,
    ShieldCheck
} from "lucide-react";
import QuotationRequestModal from './QuotationRequestModal';
function SearchPanel(props) {
    const [searchingData, setSearchingData] = useState({
        destination: "",
        start_date: new Date(),
        end_date: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
        adult: 1,
        children: 0,
        children_age: [],
        selectedRoom: {},
        filterData: {}
    })
    const [isQuotationModalOpen, setIsQuotationModalOpen] = useState(false);
    const [quotationModalType, setQuotationModalType] = useState('flight');
    const [searchingDataError, setSearchingDataError] = useState({
        destination: "",
        start_date: null,
        end_date: null,
        adult: 1,
        children: 0,
        children_age: [],
        selectedRoom: {},
        filterData: {}
    })

    const [selectedDestination, setSelectedDestination] = useState({});
    const [locationList, setLocationList] = useState([]);
    const [adultChildPlaceHolderText, setAdultChildPlaceHolderText] = useState("1 Adult - 0 Children");
    const [showPopover, setShowPopover] = useState(false);
    const [endDateMinMax, setEndDateMinMax] = useState({
        minDate: new Date(),
        maxDate: new Date(new Date().getFullYear() + 1, new Date().getMonth(), new Date().getDate() + 1)
    });
    const [childrenAgeList, setChildrenAgeList] = useState([]);
    // const childAgeinputRef = useRef(null);
    const [isChildAgeNeed, setIsChildAgeNeed] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const myParam = useParams();
    const [searchSelectedLocationChangeFlag, setSearchSelectedLocationChangeFlag] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [searchSubmitted, setSearchSubmitted] = useState(false);
    const history = useHistory();
    const location = useLocation();

    const currentPath = (location?.pathname || window.location.pathname || '').toLowerCase();
    const isSearchRoute = currentPath.includes('/search') || props.callFrom === 'search';
    const isHomeRoute = !isSearchRoute && (
        currentPath === '/' ||
        currentPath.endsWith('/home') ||
        currentPath.includes('/home') ||
        props.callFrom === 'home'
    );
    // Track whether the user has manually changed adult/child counts in this session.
    // When true, the Redux sync useEffect will NOT overwrite local guest state.
    const userEditedGuests = useRef(false);
    const prevActiveTabRef = useRef(null);
    const isTrendingInitialMount = useRef(true);
    const normalizeDestinationString = (item) => {
        if (typeof item === 'string') return item;
        if (item && typeof item === 'object') {
            const stringValue = item.location || item.name || item.city || item.state || item.label || item.value || item.title || item.display_name;
            if (typeof stringValue === 'string') return stringValue;
            const firstString = Object.values(item).find(v => typeof v === 'string' && v.trim() !== '');
            if (firstString) return firstString;
            return '';
        }
        return item !== null && item !== undefined ? String(item) : '';
    };
    const [hotelGroupPackageTour, setHotelGroupPackageTour] = useState([
        {
            "label": "Hotel",
            "value": "hotel",
            "isSelected": true,
            "icon": Hotel
        },
        {
            "label": "Homestay",
            "value": "homestay",
            "isSelected": false,
            "icon": House

        },
        {
            "label": "Package Tour",
            "value": "group_package_tour",
            "isSelected": false,
            "icon": UsersRound
        },
        {
            "label": "Fixed Departure group tour",
            "value": "fixed_departure_group_tour",
            "isSelected": false,
            "icon": TrainFront

        },
        {
            "label": "Customized Tour",
            "value": "customized_tour",
            "isSelected": false,
            "icon": Plane

        },        
        {
            "label": "Flight/Train",
            "value": "flight",
            "isSelected": false,
            "icon": Plane

        },
        // {
        //     "label": "Trains",
        //     "value": "trains",
        //     "isSelected": false,
        //     "icon": TrainFront

        // },
        // {
        //     "label": "Buses",
        //     "value": "buses",
        //     "isSelected": false,
        //     "icon": BusFront
        // },
        {
            "label": "Cabs",
            "value": "cabs",
            "isSelected": false,
            "icon": CarFront

        },
        // {
        //     "label": "Travel Insurance",
        //     "value": "insurance",
        //     "isSelected": false,
        //     "icon": ShieldCheck

        // },

    ]);
    //initially fetch filter panel options list
    useEffect(() => {
        getFilterPanelList()
    }, [])

    // fetch destinations list when trendingDestinationData changes (after mount)
    useEffect(() => {
        if (isTrendingInitialMount.current) {
            isTrendingInitialMount.current = false;
            return;
        }
        fetchDestinationsForSelectedType();
    }, [props.trendingDestinationData]);

    // Sync selected tab in hotelGroupPackageTour with URL parameter or Redux and fetch destinations once
    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const urlTourType = searchParams.get('tour_type');
        const urlPropertyType = searchParams.get('property_type');
        const reduxItem = (props.userHotelGroupPackageSelectedData && Array.isArray(props.userHotelGroupPackageSelectedData))
            ? props.userHotelGroupPackageSelectedData.find(item => item.isSelected)?.value
            : null;
        const currentSelectedTab = hotelGroupPackageTour.find(item => item.isSelected)?.value || "hotel";

        let targetTab;
        if (props.callFrom === "search") {
            targetTab = urlPropertyType === "homestay" ? "homestay" : "hotel";
        } else {
            targetTab = urlTourType || urlPropertyType || reduxItem || currentSelectedTab;
        }

        if (prevActiveTabRef.current !== targetTab) {
            prevActiveTabRef.current = targetTab;
            setHotelGroupPackageTour(prev => prev.map(item => ({
                ...item,
                isSelected: item.value === targetTab
            })));
            fetchDestinationsForSelectedType(targetTab);
        }

        if (props.callFrom === "search") {
            const hasTourSelectedInRedux = props.userHotelGroupPackageSelectedData && Array.isArray(props.userHotelGroupPackageSelectedData) &&
                props.userHotelGroupPackageSelectedData.some(item => item.isSelected && ["group_package_tour", "customized_tour", "fixed_departure_group_tour", "flight", "cabs"].includes(item.value));
            if (hasTourSelectedInRedux && props.hotelGroupPackageSelectedData) {
                const targetHotelType = urlPropertyType === "homestay" ? "homestay" : "hotel";
                const resetTabs = hotelGroupPackageTour.map(item => ({
                    ...item,
                    isSelected: item.value === targetHotelType
                }));
                props.hotelGroupPackageSelectedData(resetTabs.map(({ icon, ...rest }) => rest));
            }
        }
    }, [props.userHotelGroupPackageSelectedData, props.callFrom]);

    //after state change fetch destinations list
    useEffect(() => {
        if (searchSelectedLocationChangeFlag) {
            fetchDestinationsForSelectedType();
        }
    }, [searchSelectedLocationChangeFlag])

    // Sync SearchPanel's local state with Redux when URL parameters are loaded
    useEffect(() => {
        // Only update if userSearchDataFromReducer has data
        if (props.userSearchDataFromReducer) {
            // Create a new state object with only the fields we want to update
            const newState = {};

            // Update destination if it exists in Redux and is in the current location list
            if (props.userSearchDataFromReducer.destination) {
                const destinationText = normalizeDestinationString(props.userSearchDataFromReducer.destination);
                const matchedOpt = locationList.find(item =>
                    item.value.toLowerCase() === destinationText.toLowerCase() ||
                    destinationText.toLowerCase().includes(item.value.toLowerCase()) ||
                    item.value.toLowerCase().includes(destinationText.toLowerCase())
                );
                if (matchedOpt) {
                    newState.destination = matchedOpt.value;
                    setSelectedDestination(matchedOpt);
                } else {
                    setSelectedDestination({});
                    newState.destination = '';
                }
            }

            // Update dates if they exist in Redux
            if (props.userSearchDataFromReducer.start_date) {
                newState.start_date = new Date(props.userSearchDataFromReducer.start_date);
            }

            if (props.userSearchDataFromReducer.end_date) {
                newState.end_date = new Date(props.userSearchDataFromReducer.end_date);
            }

            // Only sync guest fields from Redux if the user has NOT manually edited
            // them in this session. If they have, their local state takes priority.
            if (!userEditedGuests.current) {
                // Update adult count if it exists in Redux
                if (props.userSearchDataFromReducer.adult !== undefined) {
                    newState.adult = props.userSearchDataFromReducer.adult;
                }

                // Update children count and ages if they exist in Redux
                if (props.userSearchDataFromReducer.children !== undefined) {
                    newState.children = props.userSearchDataFromReducer.children;

                    // Also update the placeholder text
                    setAdultChildPlaceHolderText(`${props.userSearchDataFromReducer.adult || 1} ${(props.userSearchDataFromReducer.adult === 1) ? "Adult" : "Adults"} - ${props.userSearchDataFromReducer.children} ${(props.userSearchDataFromReducer.children <= 1) ? "Child" : "Children"}`);
                }

                if (props.userSearchDataFromReducer.children_age &&
                    Array.isArray(props.userSearchDataFromReducer.children_age) &&
                    props.userSearchDataFromReducer.children_age.length > 0) {
                    newState.children_age = [...props.userSearchDataFromReducer.children_age];
                }
            }

            // Only update state if we have changes
            if (Object.keys(newState).length > 0) {
                setSearchingData(prevState => ({
                    ...prevState,
                    ...newState
                }));
            }
        }
    }, [props.userSearchDataFromReducer]);

    //when add more children smooth scroll on child age input section
    // useEffect(() => {
    //     if (searchingData.children > 2) {
    //         if (childAgeinputRef.current) {
    //             childAgeinputRef.current.scrollIntoView({ behavior: 'smooth' });
    //         }
    //     }
    // }, [searchingData.children]);

    //filter panel list get
    const getFilterPanelList = () => {
        const { loaderStateTrue, loaderStateFalse } = props;
        let data = {}
        filterPanelList(data).then((response) => {
            setChildrenAgeListFN(response.data.chaild_max_age)
            if (Object.keys(response.data).length > 0 && response.data.hasOwnProperty('property_type') && response.data.property_type.length > 0) {
                props.setPropertyTypeData(response.data.property_type);
            } else {
                props.setPropertyTypeData([]);
            }
        }).catch((error) => {
        });
    }

    //set children age list
    const setChildrenAgeListFN = (child_age_limit = 10) => {
        if (child_age_limit == 0) {
            child_age_limit = process.env.CHILD_AGE_LIMIT;
        }
        const newArray = [];
        for (let i = 1; i <= child_age_limit; i++) {
            newArray.push({ label: `${i} Year`, value: i });
        }
        setChildrenAgeList(newArray);
    }

    //fetch destination list api
    const getDestinationList = (shouldClearDestination = false) => {
        if (shouldClearDestination) {
            setSelectedDestination({});
            setSearchingData(prev => ({ ...prev, destination: '' }));
        }
        const { loaderStateTrue, loaderStateFalse } = props;
        let data = {};
        if (props.trendingDestinationData && props.trendingDestinationData.hasOwnProperty('type') && props.trendingDestinationData.type && props.trendingDestinationData.type == 'state' && !searchSelectedLocationChangeFlag) {
            data['type'] = 'state';
            data['type_name'] = props.trendingDestinationData?.location;
        }
        destinationList(data).then((response) => {
            let locationListData = [];
            if (response.data.length > 0) {
                response.data.map((e, i) => {
                    const locationText = normalizeDestinationString(e);
                    const existingDestination = shouldClearDestination ? '' : normalizeDestinationString(props.userSearchDataFromReducer?.destination);
                    const shouldAutoSelectFromTrending = !shouldClearDestination && props.trendingDestinationData && props.trendingDestinationData.hasOwnProperty('type') && props.trendingDestinationData.type && props.trendingDestinationData.type !== 'trending';

                    if (shouldAutoSelectFromTrending && props.callFrom !== 'hotel_details' && i == 0 && (searchSelectedLocationChangeFlag || !existingDestination)) {
                        let tempFormData = {};
                        if (props.trendingDestinationData && props.trendingDestinationData.hasOwnProperty('type') && props.trendingDestinationData.type && props.trendingDestinationData.type == 'state' && !searchSelectedLocationChangeFlag) {
                            tempFormData["destination"] = {}
                        } else {
                            tempFormData["destination"] = locationText
                        }
                        let reducerData = props.userSearchDataFromReducer
                        let tempSearchData = {
                            ...reducerData,
                            ...tempFormData,
                            tour_type: reducerData?.tour_type || 'hotel',
                            property_type: reducerData?.property_type || 'hotel'
                        }
                        props.userSearchData(tempSearchData)
                        if (props.trendingDestinationData && props.trendingDestinationData.hasOwnProperty('type') && props.trendingDestinationData.type && props.trendingDestinationData.type == 'state' && !searchSelectedLocationChangeFlag) {
                            setSelectedDestination({})
                        } else {
                            setSelectedDestination({ "label": locationText, "value": locationText })
                        }
                    }
                    let branchListObj = {};
                    branchListObj['label'] = locationText;
                    branchListObj['value'] = locationText;
                    locationListData.push(branchListObj)
                })
            } else {
                let searchData = { ...searchingData }
                searchData = { ...searchData, 'destination': "" }
                setSearchingData(searchData)
                setSelectedDestination({})
            }

            if (locationListData.length > 0) {
                setLocationList(locationListData);
                if (shouldClearDestination) {
                    setSelectedDestination({});
                    setSearchingData(prev => ({ ...prev, destination: '' }));
                } else {
                    const currentDest = normalizeDestinationString(props.userSearchDataFromReducer?.destination);
                    if (currentDest) {
                        const matchedOpt = locationListData.find(item =>
                            item.value.toLowerCase() === currentDest.toLowerCase() ||
                            currentDest.toLowerCase().includes(item.value.toLowerCase()) ||
                            item.value.toLowerCase().includes(currentDest.toLowerCase())
                        );
                        if (matchedOpt) {
                            setSelectedDestination(matchedOpt);
                            setSearchingData(prev => ({ ...prev, destination: matchedOpt.value }));
                        } else {
                            setSelectedDestination({});
                            setSearchingData(prev => ({ ...prev, destination: '' }));
                            let reducerData = props.userSearchDataFromReducer || {};
                            let tempSearchData = { ...reducerData, destination: '' };
                            props.userSearchData(tempSearchData);
                        }
                    } else if (props.callFrom == 'search' && searchSelectedLocationChangeFlag) {
                        setSelectedDestination(locationListData[0]);
                        let searchData = { ...searchingData };
                        searchData = { ...searchData, 'destination': locationListData[0].value };
                        setSearchingData(searchData);
                    }
                }
            } else {
                if (props.callFrom == 'search' && searchSelectedLocationChangeFlag) {
                    setSelectedDestination({});
                    let searchData = { ...searchingData };
                    searchData = { ...searchData, 'destination': '' };
                    setSearchingData(searchData);
                }
            }
            setSearchSelectedLocationChangeFlag(false)
        }).catch((error) => {
        });
    }

    // fetch tour destination list api for ["group_package_tour", "customized_tour", "fixed_departure_group_tour"]
    const getTourDestinationList = (shouldClearDestination = false) => {
        if (shouldClearDestination) {
            setSelectedDestination({});
            setSearchingData(prev => ({ ...prev, destination: '' }));
        }
        getTourLocationList().then((response) => {
            let locationListData = [];
            const rawData = response?.data || [];
            if (rawData.length > 0) {
                rawData.forEach((item) => {
                    const destName = item?.destination_name || (typeof item === 'string' ? item : '');
                    if (destName) {
                        locationListData.push({
                            label: destName,
                            value: destName,
                            id: item.id
                        });
                    }
                });
            }

            if (locationListData.length > 0) {
                setLocationList(locationListData);
                if (shouldClearDestination) {
                    setSelectedDestination({});
                    setSearchingData(prev => ({ ...prev, destination: '' }));
                } else {
                    const currentDest = normalizeDestinationString(
                        props.userGroupTourPackageSearchData?.search ||
                        props.userGroupTourPackageSearchData?.starting_from?.value ||
                        props.userSearchDataFromReducer?.destination ||
                        searchingData?.destination
                    );
                    if (currentDest) {
                        const matchedOpt = locationListData.find(item =>
                            item.value.toLowerCase() === currentDest.toLowerCase() ||
                            currentDest.toLowerCase().includes(item.value.toLowerCase()) ||
                            item.value.toLowerCase().includes(currentDest.toLowerCase())
                        );
                        if (matchedOpt) {
                            setSelectedDestination(matchedOpt);
                            setSearchingData(prev => ({ ...prev, destination: matchedOpt.value }));
                        } else {
                            setSelectedDestination({});
                            setSearchingData(prev => ({ ...prev, destination: '' }));
                        }
                    }
                }
            } else {
                setLocationList([]);
                setSelectedDestination({});
                setSearchingData(prev => ({ ...prev, destination: '' }));
            }
            setSearchSelectedLocationChangeFlag(false);
        }).catch((error) => {
            console.error("Error fetching tour destinations:", error);
            setSearchSelectedLocationChangeFlag(false);
        });
    };

    // Helper to fetch destination list based on selected service type
    const fetchDestinationsForSelectedType = (type = null) => {
        const selectedType = (props.callFrom === "search")
            ? "hotel"
            : (type || hotelGroupPackageTour.find(item => item.isSelected)?.value || "hotel");
        if (["group_package_tour", "customized_tour", "fixed_departure_group_tour"].includes(selectedType)) {
            getTourDestinationList();
        } else if (["hotel", "homestay"].includes(selectedType)) {
            getDestinationList();
        }
    };

    //search panel input field set after some change
    useEffect(() => {
        let childrenCount = Number(searchingData.children) || 0;
        let relevantAges = childrenCount > 0 ? searchingData.children_age.slice(0, childrenCount) : [];
        let allAgesNotEmpty = relevantAges.length > 0 && relevantAges.every(child => child.age !== "");
        if (allAgesNotEmpty) {
            setIsChildAgeNeed(false);
        } else {
            setIsChildAgeNeed(childrenCount > 0);
            let children_age_error = [];
            if (childrenCount > 0) {
                relevantAges.forEach(child => {
                    if (child.age == "") {
                        children_age_error.push({ age: "Required field" });
                    } else {
                        children_age_error.push({ age: "" });
                    }
                });
            }
            setSearchingDataError(prevState => ({
                ...prevState,
                children_age: children_age_error
            }));
        }

        if (searchingData.destination == "") {
            setSearchingDataError(prevState => ({
                ...prevState,
            }));
        }
        if (searchingData.start_date == "" || searchingData.start_date == null) {
            setSearchingDataError(prevState => ({
                ...prevState,
                start_date: "Required field"
            }));
        }

        if (searchingData.end_date == "" || searchingData.end_date == null) {
            setSearchingDataError(prevState => ({
                ...prevState,
                end_date: "Required field"
            }));
        }
    }, [searchingData])


    //booking search data validation
    const validSearchDataFn = () => {
        const { loaderStateTrue, loaderStateFalse, userSearchDataFromReducer } = props;
        let tempFormData = { ...searchingData };
        let tempErrorFormData = { ...searchingDataError }
        let valid = true;

        if ((userSearchDataFromReducer && userSearchDataFromReducer.end_date != "" || userSearchDataFromReducer && userSearchDataFromReducer.end_date != null) && (userSearchDataFromReducer && userSearchDataFromReducer.start_date != "" || userSearchDataFromReducer && userSearchDataFromReducer.start_date != null)) {
            const startDate = new Date(userSearchDataFromReducer.start_date);
            const endDate = new Date(userSearchDataFromReducer.end_date);
            const timeDifference = endDate.getTime() - startDate.getTime();
            const differenceInDays = timeDifference / (1000 * 3600 * 24);
            if (differenceInDays > 30) {
                valid = false;
                tempErrorFormData['end_date'] = "Required field";
                setSearchingDataError(tempErrorFormData)
                Utility.toastNotifications("Sorry, reservations for more than 30 nights are not possible.", "Warning", "warning");
            }
        }
        if (userSearchDataFromReducer && userSearchDataFromReducer.hasOwnProperty('end_date') && userSearchDataFromReducer.end_date == null) {
            valid = false
        }

        return valid;
    }


    // Removed redundant redux sync search to prevent multiple API calls

    //date range picker onblur event
    const handleBlur = () => {
        if (!searchingData.end_date && searchingData.start_date) {
            const nextDay = new Date(searchingData.start_date);
            nextDay.setDate(nextDay.getDate() + 1);

            // Make sure the auto-selected end date is within the 30-day constraint
            const maxAllowedEndDate = new Date(searchingData.start_date);
            maxAllowedEndDate.setDate(maxAllowedEndDate.getDate() + 30);

            // If nextDay is after maxAllowedEndDate, use maxAllowedEndDate instead
            const endDate = nextDay <= maxAllowedEndDate ? nextDay : maxAllowedEndDate;

            handelChangeSearch([searchingData.start_date, endDate], 'date');
        }
    };

    //clear state value
    const clearStateValue = (event, type) => {
        if (props.callFrom != "hotel_details") {
            let trendingData = { 'location': '', 'type': '' }
            props.trendingDestination(trendingData);
            setSearchSelectedLocationChangeFlag(true)
        } else {
            let trendingData = { 'location': '', 'type': '' }
            props.trendingDestination(trendingData);
            setSearchSelectedLocationChangeFlag(true)
            let reducerData = props.userSearchDataFromReducer
            let tempSearchData = { ...reducerData, "destination": "" }
            props.userSearchData(tempSearchData)
            history.push(`/${localStorage.getItem('i18nextLng')}/search`);
        }
    }

    //search panel inuts onchange event
    const handelChangeSearch = (event, type) => {
        let tempFormData = { ...searchingData };
        let tempErrorFormData = { ...searchingDataError }
        if (type == "search_destination") {
            setSearchSubmitted(false);
            if (event) {
                let reducerData = props.userSearchDataFromReducer
                let tempSearchData = { ...reducerData, "destination": event.value }
                props.userSearchData(tempSearchData)
                tempFormData["destination"] = event.value
                tempErrorFormData['destination'] = ""
                setSelectedDestination(event)
                if (props.groupTourPackageSearchData) {
                    let groupReducer = props.userGroupTourPackageSearchData || {};
                    props.groupTourPackageSearchData({
                        ...groupReducer,
                        starting_from: { label: event.value, value: event.value },
                        search: event.value
                    });
                }
                if (props.callFrom == "search") {
                    const { country, ...reducerRest } = reducerData;
                    const freshSearchData = {
                        ...reducerRest,
                        destination: event.value,
                        start_date: tempFormData.start_date,
                        end_date: tempFormData.end_date,
                        adult: tempFormData.adult,
                        children: tempFormData.children,
                        children_age: tempFormData.children_age,
                        tour_type: reducerData?.tour_type || 'hotel',
                        property_type: new URLSearchParams(window.location.search).get('property_type') === "homestay" ? "homestay" : (reducerData?.property_type || "hotel"),
                    };
                    if (freshSearchData.start_date && freshSearchData.end_date && freshSearchData.adult) {
                        searchHotelBranch(freshSearchData);
                    }
                }
            } else {
                tempErrorFormData['destination'] = ""
                tempFormData["destination"] = ""
                if (props.groupTourPackageSearchData) {
                    let groupReducer = props.userGroupTourPackageSearchData || {};
                    props.groupTourPackageSearchData({
                        ...groupReducer,
                        starting_from: null,
                        search: ""
                    });
                }
            }
            if (props.callFrom == "hotel_details") {
                let reducerData = props.userSearchDataFromReducer
                let tempSearchData = { ...reducerData, "destination": event.value }
                props.userSearchData(tempSearchData)
                history.push(`/${localStorage.getItem('i18nextLng')}/search`);
            }
        }

        if (type == "date") {
            if (event) {
                let [start, end] = event;
                if (end && start.getTime() === end.getTime()) {
                    return;
                }

                // When start date is selected, update min/max constraints for end date
                if (start) {
                    // Calculate the end date constraints: min is start date, max is start date + 30 days
                    const maxDate = new Date(start);
                    maxDate.setDate(maxDate.getDate() + 30);

                    setEndDateMinMax({
                        minDate: start,
                        maxDate: maxDate
                    });

                    // If end date is outside the new constraints, reset it
                    if (end) {
                        const endTime = end.getTime();
                        if (endTime < start.getTime() || endTime > maxDate.getTime()) {
                            end = null;
                        }
                    }
                }

                tempFormData["start_date"] = start
                tempFormData["end_date"] = end
                tempErrorFormData['start_date'] = ""
                tempErrorFormData['end_date'] = ""

                if (start && end) {
                    let reducerData = props.userSearchDataFromReducer || {};
                    let tempSearchData = { ...reducerData, start_date: start, end_date: end };
                    props.userSearchData(tempSearchData);

                    if (props.groupTourPackageSearchData) {
                        let groupReducer = props.userGroupTourPackageSearchData || {};
                        props.groupTourPackageSearchData({
                            ...groupReducer,
                            start_date: start,
                            end_date: end
                        });
                    }

                    if (typeof props.onDateChange === "function") {
                        props.onDateChange(start, end);
                    }

                    if (props.callFrom === "hotel_details") {
                        history.push(`/${localStorage.getItem("i18nextLng")}/search`);
                    }
                }
            } else {
                tempFormData["start_date"] = ""
                tempFormData["end_date"] = ""
                tempErrorFormData['start_date'] = ""
                tempErrorFormData['end_date'] = ""

                let reducerData = props.userSearchDataFromReducer || {};
                let tempSearchData = { ...reducerData, start_date: "", end_date: "" };
                props.userSearchData(tempSearchData);

                if (props.groupTourPackageSearchData) {
                    let groupReducer = props.userGroupTourPackageSearchData || {};
                    props.groupTourPackageSearchData({
                        ...groupReducer,
                        start_date: "",
                        end_date: ""
                    });
                }

                if (typeof props.onDateChange === "function") {
                    props.onDateChange(null, null);
                }
            }
        }

        if (type == "adult") {
            if (event) {
                tempFormData["adult"] = event.target.value
                tempErrorFormData['adult'] = ""
                tempErrorFormData['children'] = ""
            } else {
                tempErrorFormData['adult'] = ""
                tempErrorFormData['children'] = ""
                tempFormData["adult"] = 1
            }
        }

        if (type == "children") {
            if (event) {
                tempFormData["children"] = event.target.value
                tempErrorFormData['children'] = ""
                tempErrorFormData['adult'] = ""
            } else {
                tempErrorFormData['children'] = ""
                tempErrorFormData['adult'] = ""
                tempFormData["children"] = 0
            }
        }

        if (type == "adult-inc") {
            if (event) {
                userEditedGuests.current = true;
                tempFormData["adult"] = Number(searchingData.adult) + 1
                tempErrorFormData['adult'] = ""
                setAdultChildPlaceHolderText(`${(Number(searchingData.adult) + 1)} ${(Number(searchingData.adult) + 1) > 1 ? "Adults" : "Adult"} - ${searchingData.children} ${(searchingData.children <= 1) ? "Child" : "Children"}`)
            } else {
                tempFormData["adult"] = 0
                tempErrorFormData['adult'] = ""
            }
        }

        if (type == "adult-dec") {
            if (event) {
                userEditedGuests.current = true;
                tempFormData["adult"] = Number(searchingData.adult) - 1
                tempErrorFormData['adult'] = ""

                setAdultChildPlaceHolderText(`${Number(searchingData.adult) - 1} ${(Number(searchingData.adult) - 1 > 1) ? "Adults" : "Adult"} - ${searchingData.children} ${(searchingData.children <= 1) ? "Child" : "Children"}`);

            } else {
                tempFormData["adult"] = 1
                tempErrorFormData['adult'] = ""
            }
        }

        if (type == "child-inc") {
            if (event) {
                userEditedGuests.current = true;
                tempFormData["children"] = Number(searchingData.children) + 1
                tempErrorFormData['children'] = ""
                const adultCount = searchingData.adult;
                const childCount = Number(searchingData.children) + 1;
                const childOrChildren = childCount <= 1 ? "Child" : "Children";
                const adultOrAdults = Number(adultCount) <= 1 ? "Adult" : "Adults";
                setAdultChildPlaceHolderText(`${adultCount} ${adultOrAdults} - ${childCount} ${childOrChildren}`);
                tempFormData['children_age'].push({ age: "" })
                if (props.userSearchDataFromReducer?.children_age && props.userSearchDataFromReducer.children_age.length > 0) {
                    tempErrorFormData['children_age'].push({ age: "" });
                } else {
                    tempErrorFormData['children_age'].push({ age: "" })
                }

            } else {
                tempErrorFormData['children'] = ""
                tempFormData["children"] = 0
            }
        }

        if (type == "child-dec") {
            if (event) {
                userEditedGuests.current = true;
                tempFormData["children"] = Number(searchingData.children) - 1
                tempErrorFormData['children'] = ""
                setAdultChildPlaceHolderText(`${searchingData.adult} ${(searchingData.adult === 1) ? "Adult" : "Adults"} - ${Number(searchingData.children) - 1} ${(Number(searchingData.children) - 1 <= 1) ? "Child" : "Children"}`);
            } else {
                tempErrorFormData['children'] = ""
                tempFormData["children"] = 0
            }
        }

        const newChildrenCount = Number(tempFormData.children) || 0;
        const newChildrenAge = [...tempFormData.children_age];
        const newChildrenAgeError = [...tempErrorFormData.children_age];

        while (newChildrenAge.length > newChildrenCount) {
            newChildrenAge.pop();
            newChildrenAgeError.pop();
        }
        while (newChildrenAge.length < newChildrenCount) {
            newChildrenAge.push({ age: "" });
            newChildrenAgeError.push({ age: "" });
        }

        tempFormData['children_age'] = newChildrenAge;
        tempErrorFormData['children_age'] = newChildrenAgeError;

        setSearchingData(tempFormData)
        setSearchingDataError(tempErrorFormData)
    }

    // Keep track of current search data without dispatching on every change
    // We'll only dispatch when the search button is clicked
    // const lastSearchData = useRef(null);

    // // Update lastSearchData ref when searchingData changes, but don't dispatch actions
    // useEffect(() => {
    //     if (searchingData) {
    //         lastSearchData.current = { ...searchingData };
    //         // console.log('Search data updated but not dispatched (waiting for search button click)');
    //     }
    // }, [searchingData]);

    // Function to manually dispatch search data when search button is clicked
    const dispatchSearchData = () => {
        // if (searchingData) {
        const reducerData = props.userSearchDataFromReducer || {};
        const { country, ...reducerDataCopy } = reducerData;
        // Always spread all guest-related fields from local state so
        // adult / children / children_age are never stale in Redux.
        const tempSearchData = {
            ...reducerDataCopy,
            destination: searchingData.destination,
            start_date: searchingData.start_date,
            end_date: searchingData.end_date,
            adult: searchingData.adult,
            children: searchingData.children,
            children_age: searchingData.children_age,
            property_type: (props.callFrom === "search")
                ? (new URLSearchParams(window.location.search).get('property_type') === "homestay" ? "homestay" : "hotel")
                : (hotelGroupPackageTour.find(item => item.isSelected)?.value ?? "hotel"),
        };
        // Update Redux for persistence, then trigger search with fresh data directly
        props.userSearchData(tempSearchData);
        // Pass tempSearchData directly so the parent searchHotelBranch uses
        // the fresh local values (Redux dispatch is async, so calling
        // props.searchHotelBranch() with no args would pick up stale Redux state).
        searchHotelBranch(tempSearchData);
        // }
    };

    useEffect(() => {
        if (searchingDataError) {
            let searchDataError = props.userSearchErrorDataFromReducer
            let tempSearchDataError = { ...searchDataError, ...searchingDataError }
            props.userSearchDataError(tempSearchDataError)
        }
    }, [searchingDataError])


    //initially set search panel data
    useEffect(() => {
        let childrenAgeArr = []
        if (props.userSearchDataFromReducer && props.userSearchDataFromReducer.hasOwnProperty("children_age") && props.userSearchDataFromReducer.children_age && props.userSearchDataFromReducer.children_age.length > 0) {
            childrenAgeArr = props.userSearchDataFromReducer.children_age
        }
        let childrenCount = props.userSearchDataFromReducer && props.userSearchDataFromReducer.hasOwnProperty("children") ? Number(props.userSearchDataFromReducer.children) || 0 : 0;
        childrenAgeArr = childrenAgeArr.slice(0, childrenCount);
        while (childrenAgeArr.length < childrenCount) {
            childrenAgeArr.push({ age: "" });
        }
        if (props.userSearchDataFromReducer && Object.keys(props.userSearchDataFromReducer).length > 0) {
            const today = moment();
            let modifiedStartDate = props.userSearchDataFromReducer.hasOwnProperty("start_date") && props.userSearchDataFromReducer.start_date ? moment(props.userSearchDataFromReducer.start_date) : null;
            let modifiedEndDate = props.userSearchDataFromReducer.hasOwnProperty("end_date") && props.userSearchDataFromReducer.end_date ? moment(props.userSearchDataFromReducer.end_date) : null;

            if (modifiedStartDate && modifiedStartDate.isBefore(today, 'day')) {
                modifiedStartDate = today;
                modifiedEndDate = moment(today).add(1, 'day');
            }

            const formattedStartDate = modifiedStartDate ? modifiedStartDate.toDate() : new Date();
            const formattedEndDate = modifiedEndDate ? modifiedEndDate.toDate() : new Date(new Date().getTime() + 24 * 60 * 60 * 1000);

            setSearchingData({
                destination: props.userSearchDataFromReducer.hasOwnProperty("destination") ? normalizeDestinationString(props.userSearchDataFromReducer.destination) : "",
                start_date: formattedStartDate,
                end_date: formattedEndDate,
                adult: props.userSearchDataFromReducer.hasOwnProperty("adult") ? props.userSearchDataFromReducer.adult : "",
                children: props.userSearchDataFromReducer.hasOwnProperty("children") ? props.userSearchDataFromReducer.children : "",
                children_age: childrenAgeArr
            });
            if (props.trendingDestinationData && props.trendingDestinationData.hasOwnProperty('type') && props.trendingDestinationData.type && props.trendingDestinationData.type == 'state' && !searchSelectedLocationChangeFlag) {
                setSelectedDestination({})
            } else {
                setSelectedDestination({ "label": normalizeDestinationString(props.userSearchDataFromReducer.destination), "value": normalizeDestinationString(props.userSearchDataFromReducer.destination) })
            }
            setAdultChildPlaceHolderText(`${props.userSearchDataFromReducer.adult} ${props.userSearchDataFromReducer.adult > 1 ? "Adults" : "Adult"} - ${props.userSearchDataFromReducer.children} ${props.userSearchDataFromReducer.children <= 1 ? "Child" : "Children"}`)
        }

        if (props.userSearchErrorDataFromReducer && Object.keys(props.userSearchErrorDataFromReducer).length > 0) {
            let children_age = props.userSearchDataFromReducer?.hasOwnProperty("children_age") && props.userSearchDataFromReducer?.children_age != null ? props.userSearchDataFromReducer?.children_age : [];
            let children_age_error = [];
            if (children_age.length > 0) {
                children_age.forEach(child => {
                    if (child.age == "") {
                        children_age_error.push({ age: "Required field" });
                    } else {
                        children_age_error.push({ age: "" });
                    }
                });
            }
            setSearchingDataError({
                destination: props.userSearchErrorDataFromReducer.hasOwnProperty("destination") && props.userSearchErrorDataFromReducer.destination ? props.userSearchErrorDataFromReducer.destination : "",

                start_date: props.userSearchErrorDataFromReducer.hasOwnProperty("start_date") && props.userSearchErrorDataFromReducer.start_date ? props.userSearchErrorDataFromReducer.start_date : null,
                end_date: props.userSearchErrorDataFromReducer.hasOwnProperty("end_date") && props.userSearchErrorDataFromReducer.end_date ? props.userSearchErrorDataFromReducer.end_date : null,
                adult: props.userSearchErrorDataFromReducer.hasOwnProperty("adult") && props.userSearchErrorDataFromReducer.adult ? props.userSearchErrorDataFromReducer.adult : 1,
                children: props.userSearchErrorDataFromReducer.hasOwnProperty("children") && props.userSearchErrorDataFromReducer.children ? props.userSearchErrorDataFromReducer.children : 0,
                children_age: children_age_error,
                selectedRoom: props.userSearchErrorDataFromReducer.hasOwnProperty("selectedRoom") && props.userSearchErrorDataFromReducer.selectedRoom ? props.userSearchErrorDataFromReducer.selectedRoom : {},
                filterData: props.userSearchErrorDataFromReducer.hasOwnProperty("filterData") && props.userSearchErrorDataFromReducer.filterData ? props.userSearchErrorDataFromReducer.filterData : {},
            })

            if (props.userSearchErrorDataFromReducer.children_age && props.userSearchErrorDataFromReducer.children_age.length > 0) {

                props.userSearchErrorDataFromReducer.children_age.map((val, idx) => {
                    if (val.age == "Required field") {
                    }
                })
            }
        }
    }, [])


    //validate branch search data before api hits
    const validSearchData = () => {
        let tempFormData = { ...searchingData };
        let tempErrorFormData = { ...searchingDataError }
        let childrenAgesTemp = tempFormData.children_age.slice();
        let childrenAgesErrorTemp = tempErrorFormData.children_age.slice();
        let valid = true
        if (tempFormData.destination == "") {
            tempErrorFormData['destination'] = "Required field"
            valid = false
            Utility.toastNotifications("Please select your location where you want to go.", "Warning", "warning");
        }
        if (tempFormData.start_date == "" || tempFormData.start_date == null) {
            tempErrorFormData['start_date'] = "Required field"
            valid = false
            Utility.toastNotifications("Please select your check-in date.", "Warning", "warning");
        }
        if (tempFormData.end_date == "" || tempFormData.end_date == null) {
            tempErrorFormData['end_date'] = new Date(new Date().getTime() + 24 * 60 * 60 * 1000)
        }
        if ((tempFormData.end_date != "" || tempFormData.end_date != null) && (tempFormData.start_date != "" || tempFormData.start_date != null)) {
            const startDate = new Date(tempFormData.start_date);
            const endDate = new Date(tempFormData.end_date);
            const timeDifference = endDate.getTime() - startDate.getTime();
            const differenceInDays = timeDifference / (1000 * 3600 * 24);
            if (differenceInDays > 30) {
                valid = false;
                tempErrorFormData['end_date'] = "Required field"
                Utility.toastNotifications("Sorry, reservations for more than 30 nights are not possible.", "Warning", "warning");
            }
        }
        // if (childrenAgesTemp.length > 0) {
        //     childrenAgesTemp.map((val, idx) => {
        //         if (val.age == "") {
        //             childrenAgesErrorTemp[idx].age = "Required field";
        //             valid = false;
        //         } else {
        //             childrenAgesErrorTemp[idx].age = ""
        //         }
        //     })
        // }
        setSearchingDataError({
            ...tempErrorFormData,
            children_age: childrenAgesErrorTemp
        });
        return valid;
    }

    //search hotel branch api
    // Accepts optional freshData so the caller can pass local state directly
    // instead of relying on the async Redux update having already settled.
    const searchHotelBranch = Utility.debounceButton((freshData) => {
        let valid = validSearchData()
        if (valid) {
            // Build the payload: prefer freshData (passed from dispatchSearchData)
            // so adult/children/children_age are never stale.
            const reducerData = props.userSearchDataFromReducer || {};
            const tempSearchData = freshData || {
                ...reducerData,
                destination: searchingData.destination,
                start_date: searchingData.start_date,
                end_date: searchingData.end_date,
                adult: searchingData.adult,
                children: searchingData.children,
                children_age: searchingData.children_age,
                tour_type: reducerData?.tour_type || (hotelGroupPackageTour.find(item => item.isSelected)?.value ?? "hotel"),
                property_type: (props.callFrom === "search")
                    ? (new URLSearchParams(window.location.search).get('property_type') === "homestay" ? "homestay" : (reducerData?.property_type || "hotel"))
                    : (hotelGroupPackageTour.find(item => item.isSelected)?.value ?? "hotel"),
            };
            const selectedTab = (props.callFrom === "search")
                ? "hotel"
                : (hotelGroupPackageTour.find(item => item.isSelected)?.value ?? "hotel");

            if (props.callFrom !== "search") {
                if (selectedTab === "flight" || selectedTab === "cabs" || selectedTab === "trains" || selectedTab === "train" || selectedTab === "customized_tour") {
                    setQuotationModalType(selectedTab === "trains" ? "train" : selectedTab);
                    setIsQuotationModalOpen(true);
                    return;
                }
                if (["group_package_tour", "customized_tour", "fixed_departure_group_tour"].includes(selectedTab)) {
                    let searchReducerData = props.userGroupTourPackageSearchData || {};
                    const destVal = searchingData?.destination || "";
                    const startDate = tempSearchData?.start_date || searchingData?.start_date;
                    const endDate = tempSearchData?.end_date || searchingData?.end_date;

                    const formattedStartDate = (startDate && moment(startDate).isValid())
                        ? moment(startDate).format('YYYY-MM-DD')
                        : '';
                    const formattedEndDate = (endDate && moment(endDate).isValid())
                        ? moment(endDate).format('YYYY-MM-DD')
                        : '';

                    let tempSearchReducerData = {
                        ...searchReducerData,
                        tour_type: selectedTab,
                        search: '',
                        ...(destVal ? { starting_from: { label: destVal, value: destVal } } : {}),
                        ...(startDate ? { start_date: startDate } : {}),
                        ...(endDate ? { end_date: endDate } : {})
                    };
                    if (props.groupTourPackageSearchData) {
                        props.groupTourPackageSearchData(tempSearchReducerData);
                    }
                    const searchParam = destVal ? `&from=${encodeURIComponent(destVal)}` : '';
                    const startDateParam = formattedStartDate ? `&start_date=${encodeURIComponent(formattedStartDate)}` : '';
                    const endDateParam = formattedEndDate ? `&end_date=${encodeURIComponent(formattedEndDate)}` : '';

                    console.log("bapan----", `/${localStorage.getItem('i18nextLng')}/tour-list?tour_type=${selectedTab}${searchParam}${startDateParam}${endDateParam}`);
                    history.push(`/${localStorage.getItem('i18nextLng')}/tour-list?tour_type=${selectedTab}${searchParam}${startDateParam}${endDateParam}`);
                    return;
                }
            }

            // Keep Redux in sync regardless
            props.userSearchData(tempSearchData);

            if (props.callFrom === "home") {
                let trendingData = { 'location': '', 'type': '' };
                props.trendingDestination(trendingData);
                // Pass fresh data so parent SearchPage API call uses correct values
                props.searchHotelBranch(tempSearchData);
            } else if (props.callFrom === "hotel_details") {
                history.push(`/${localStorage.getItem("i18nextLng")}/search`);
                props.searchHotelBranch(tempSearchData);
            } else {
                // 'search' callFrom — pass data directly to parent
                props.searchHotelBranch(tempSearchData);
            }
        }
    }, 300);

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
        }),
        menu: (provided, state) => ({
            ...provided,
            position: "fixed",
            width: "50%",
            right: 40,
            background: "white",
            border: "1px solid #D6D6D6",
            borderRadius: "4px",
        }),
        option: (provided, state) => ({
            ...provided,
        })

    };

    //child age input ui
    const childAgeDropdownUi = () => {
        console.log("searchingData", searchingData);
        console.log("searchingData.children", searchingData.children);
        if (!searchingData || !searchingData.children) {
            return null;
        }
        let childrenData = searchingData.children;
        let arry = [];
        for (let i = 0; i < childrenData; i++) {
            arry.push(
                <div className={searchingDataError.children_age[i]?.age && searchingDataError.children_age[i]?.age == "Required field" ? "dropdowninnerbox searchError" : "dropdowninnerbox"} key={i}>
                    <Select
                        onChange={(e) => handelChangeChildrenAge(e, i, "childrenAge")}
                        options={childrenAgeList}
                        name='children_age'
                        placeholder="Age needed"
                        isSearchable={true}
                        menuShouldScrollIntoView={true}
                        menuPlacement="bottom"
                        styles={customStyles}
                        maxMenuHeight={150}
                        value={Array.isArray(childrenAgeList) && childrenAgeList.find(option => option.value == (searchingData.children_age[i]?.age?.value ?? searchingData.children_age[i]?.age)) || null}
                    />
                </div>
            )
        }

        return arry;
    }

    //child age entry onchange event
    const handelChangeChildrenAge = (event, idx, type) => {
        let tempFormData = { ...searchingData };
        let tempErrorFormData = { ...searchingDataError }
        let childrenAgesTemp = tempFormData.children_age.slice();
        let childrenAgesErrorTemp = tempErrorFormData.children_age.slice();
        if (type == "childrenAge") {
            if (event) {
                childrenAgesTemp[idx] = { ...childrenAgesTemp[idx], "age": event };
                childrenAgesErrorTemp[idx] = { ...childrenAgesErrorTemp[idx], "age": "" };
            } else {
                childrenAgesTemp[idx] = { ...childrenAgesTemp[idx], "age": "" };
                childrenAgesErrorTemp[idx] = { ...childrenAgesErrorTemp[idx], "age": "" };
            }
        }
        setSearchingData({
            ...tempFormData,
            children_age: childrenAgesTemp
        });
        setSearchingDataError({
            ...tempErrorFormData,
            children_age: childrenAgesErrorTemp
        });
    }

    //when child age inputable overlay is open , this time validate the data
    useEffect(() => {
        const { userSearchDataFromReducer } = props;
        let valid = validSearchDataFn()
        if (props.callFrom != "hotel_details" && props.callFrom == "search" && userSearchDataFromReducer?.start_date && userSearchDataFromReducer.start_date != "" && userSearchDataFromReducer?.end_date && userSearchDataFromReducer.end_date != "" && userSearchDataFromReducer?.destination && userSearchDataFromReducer.destination != "" && userSearchDataFromReducer?.adult && userSearchDataFromReducer.adult != "" && !showOverlay && valid) {
            let allAgesNotEmpty = userSearchDataFromReducer?.children_age?.every(child => child.age !== "");
            if (allAgesNotEmpty) {
                props.searchHotelBranch();
            } else {
                props.searchDateValidation()
            }
        }
        if (!valid) {
            props.searchDateValidation()
        }
    }, [showOverlay])

    const handleOverlayToggle = () => {
        setShowOverlay(!showOverlay);
    };
    const handlePopoverExited = () => {
        setShowOverlay(false);
    };

    //cancel/modify button onchange event
    const clearLocationAndDates = () => {
        setSearchingData({
            destination: "",
            start_date: new Date(),
            end_date: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
            adult: 1,
            children: 0,
            children_age: [],
            selectedRoom: {},
            filterData: {}
        })
        setSearchingDataError({
            destination: "",
            start_date: null,
            end_date: null,
            adult: 1,
            children: 0,
            children_age: [],
            selectedRoom: {},
            filterData: {}
        })
        setSelectedDestination({})
        setAdultChildPlaceHolderText("1 Adult - 0 Child")
        setSearchSubmitted(false);

        const resetStartDate = new Date();
        const resetEndDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
        let reducerData = props.userSearchDataFromReducer || {};
        props.userSearchData({
            ...reducerData,
            destination: "",
            start_date: resetStartDate,
            end_date: resetEndDate
        });
        if (props.groupTourPackageSearchData) {
            let groupReducer = props.userGroupTourPackageSearchData || {};
            props.groupTourPackageSearchData({
                ...groupReducer,
                starting_from: null,
                search: "",
                start_date: resetStartDate,
                end_date: resetEndDate
            });
        }
        if (typeof props.onDateChange === "function") {
            props.onDateChange(resetStartDate, resetEndDate);
        }
    }


    useEffect(() => {
    }, [searchingDataError])

    //destination field focus event
    const handleFocus = () => {
        setIsFocused(true);
        setSearchSubmitted(false);
    };

    //destination field on blur event
    const handleOnBlurChange = () => {
        setIsFocused(false);
    };

    const hotelGroupPackageButtonUi = () => {
        if (!isHomeRoute) return null;
        let array = [];
        hotelGroupPackageTour.length > 0 && hotelGroupPackageTour.map((val, index) => {
            const Icon = val.icon;
            array.push(
                <div key={index} className={`hotel-group-tour-btn-group ${val.isSelected ? "active-group" : ""}`}>
                    <button type='button' className={`hotel-group-tour ${val.isSelected ? "active" : ""}`} onClick={() => hotelGroupTour(val.value, val.isSelected)}>
                        {Icon && (typeof Icon === 'function' || typeof Icon === 'object') ? (
                            <Icon
                                className="hotel-group-tour-icon"
                                size={21}
                                strokeWidth={1.8}
                            />
                        ) : null}
                        {val.label}
                    </button>
                </div>
            )
        })
        return array;
    }

    const hotelGroupTour = (type, active) => {
        const groupA = ["hotel", "homestay", "flight", "cabs", "trains", "train"];
        const groupB = ["fixed_departure_group_tour", "customized_tour", "group_package_tour"];

        const previousTab = hotelGroupPackageTour.find(item => item.isSelected)?.value || "hotel";
        const isFromA = groupA.includes(previousTab);
        const isFromB = groupB.includes(previousTab);
        const isToA = groupA.includes(type);
        const isToB = groupB.includes(type);

        const isGroupChanged = (isFromA && isToB) || (isFromB && isToA);

        prevActiveTabRef.current = type;

        // If flight, cabs, train or customized tour is clicked, open quotation modal
        if (type === "flight" || type === "cabs" || type === "trains" || type === "train" || type === "customized_tour") {
            setQuotationModalType(type === "trains" ? "train" : type);
            setIsQuotationModalOpen(true);
        }

        // return false
        let tempHotelGroupPackageTour = [...hotelGroupPackageTour];
        tempHotelGroupPackageTour = tempHotelGroupPackageTour.map(e => {
            if (e.value === type) {
                return { ...e, isSelected: true };
            } else {
                return { ...e, isSelected: false };
            }
        });
        setHotelGroupPackageTour(tempHotelGroupPackageTour);
        props.hotelGroupPackageSelectedData(tempHotelGroupPackageTour.map(({ icon, ...rest }) => rest));

        if (isGroupChanged) {
            // Two groups changed (A to B or B to A): clear selectedDestination value
            setSelectedDestination({});
            setSearchingData(prev => ({ ...prev, destination: '' }));

            const reducerData = props.userSearchDataFromReducer || {};
            props.userSearchData({
                ...reducerData,
                destination: ''
            });

            if (props.groupTourPackageSearchData) {
                const groupReducer = props.userGroupTourPackageSearchData || {};
                props.groupTourPackageSearchData({
                    ...groupReducer,
                    starting_from: null,
                    search: ''
                });
            }
        }

        if (type === "flight" || type === "cabs" || type === "trains" || type === "train" || type === "customized_tour") {
            return;
        }

        if (groupB.includes(type)) {
            // When coming from group A, fetch tour destinations and clear selectedDestination
            if (isFromA) {
                getTourDestinationList(true);
            } else if (locationList.length === 0) {
                getTourDestinationList(false);
            }
            let searchReducerData = props.userGroupTourPackageSearchData || {};
            let tempSearchReducerData = {
                ...searchReducerData,
                tour_type: type
            };
            if (props.groupTourPackageSearchData) {
                props.groupTourPackageSearchData(tempSearchReducerData);
            }
            if (props.callFrom !== "home" && !isHomeRoute) {
                history.push(`/${localStorage.getItem('i18nextLng')}/tour-list?tour_type=${type}`);
            }
        } else if (["hotel", "homestay"].includes(type)) {
            // Only call getDestinationList when coming from group B (fixed_departure_group_tour, customized_tour, group_package_tour)
            // Do NOT call getDestinationList when changing within group A (e.g. hotel <-> homestay)
            if (isFromB) {
                getDestinationList(true);
            } else if (locationList.length === 0) {
                getDestinationList(false);
            }
            const reducerData = props.userSearchDataFromReducer || {};
            console.log("reducerData: ", reducerData);
            let updatedFilterData = { ...(reducerData.filterData || {}), property_type: [type] };
            const currentDestinationVal = isGroupChanged ? '' : searchingData.destination;
            const tempSearchData = {
                ...reducerData,
                destination: currentDestinationVal,
                start_date: searchingData.start_date,
                end_date: searchingData.end_date,
                adult: searchingData.adult,
                children: searchingData.children,
                children_age: searchingData.children_age,
                tour_type: type,
                property_type: type,
                filterData: updatedFilterData
            };
            props.userSearchData(tempSearchData);
            if (props.callFrom === "search" || history.location.pathname.includes("/search")) {
                if (props.searchHotelBranch) {
                    props.searchHotelBranch(tempSearchData);
                }
            }
        }
    }

    const isSearchDisabled = isHomeRoute && ["customized_tour", "flight", "cabs"].includes(
        hotelGroupPackageTour.find(item => item.isSelected)?.value
    );

    return (
        <>
            {/* <div className={props.trendingDestinationData && props.trendingDestinationData.hasOwnProperty('type') && props.trendingDestinationData.type && props.trendingDestinationData.type == 'state' ? "search-panel-slider stateFilter" : 'search-panel-slider'}> */}
            <div
                className={`
        search-panel-slider
        ${isHomeRoute ? "search-panel-home" : "search-panel-inner"}
        ${props.trendingDestinationData &&
                        props.trendingDestinationData.hasOwnProperty("type") &&
                        props.trendingDestinationData.type === "state"
                        ? "stateFilter"
                        : ""
                    }
    `}
            >
                {isHomeRoute && (
                    <div
                        className={`
            hotel-group-package-tour-box-home
            ${props.userSearchErrorDataFromReducer &&
                                props.userSearchErrorDataFromReducer.destination === "Required field"
                                ? "required-destination"
                                : ""
                            }
        `}
                    >
                        <div className="container">
                            <div className="inn-search-panel-slider">
                                <div className="hotel-group-package-tour-box-buttons">
                                    {hotelGroupPackageButtonUi()}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <div className='container'>
                    <div className='inn-search-panel-slider'>
                        <div className='row search-cover'>
                            {(searchSubmitted && props.userSearchErrorDataFromReducer && props.userSearchErrorDataFromReducer.destination == "Required field") && (!isFocused) &&
                                <div className='location errorMsgBox'>
                                    <label>Please enter a destination to start searching.</label>
                                </div>
                            }
                            {props.trendingDestinationData && props.trendingDestinationData.hasOwnProperty('type') && props.trendingDestinationData.type && props.trendingDestinationData.type == 'state' &&
                                <div className='col-sm-2 paddingL8 searchLocation'>
                                    <div className='rows'>
                                        <div className='search-panel-slider-box locationSearch'>
                                            {props.trendingDestinationData.location && (
                                                <>
                                                    <div className='locWithIcon'>
                                                        <i className="fa fa-globe" aria-hidden="true"></i>
                                                        <span>{props.trendingDestinationData.location}</span>
                                                    </div>
                                                    <button className='clearBtn' onClick={(e) => clearStateValue(e, 'clear_state')}>✖</button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>}
                            <div className='col-sm-3 paddingL8 firstcolmn'>
                                <div className='row'>
                                    <div className='search-panel-slider-box destinationSearch'>
                                        <ErrorBoundary title="Search destination Error">
                                            <div className={searchSubmitted && props.userSearchErrorDataFromReducer && props.userSearchErrorDataFromReducer.destination == "Required field" ? "dropdowninnerbox searchError" : "dropdowninnerbox"}>
                                                <img className="ico ico-location" src={require('../../../../Utility/Public/images/location1.png')} />
                                                <h5>Location</h5>
                                                <AutosuggestComponent
                                                    handleOnChange={(e) => handelChangeSearch(e, 'search_destination')}
                                                    options={locationList}
                                                    selectedValue={Object.keys(selectedDestination).length > 0 && selectedDestination.label != "" ? selectedDestination : { value: 'default', label: 'Where are you going?', isDisabled: true, isHidden: true }}
                                                    name='destination'
                                                    isMulti={false}
                                                    placeholder="Where are you going?"
                                                    isDisabled={false}
                                                    isSearchable={true}
                                                    handleOnBlurChange={handleOnBlurChange}
                                                    handleFocus={handleFocus}
                                                />
                                            </div>
                                            <div className="col-md-12 errorClass error_div"></div>
                                        </ErrorBoundary>
                                    </div>
                                </div>
                            </div>
                            {/* } */}
                            <div className='col-sm-3 paddingR8'>
                                <div className='row'>
                                    <div className='datePickerBoxCover'>
                                        <div className='datePickerBoxes'>
                                            {searchingData.start_date != null ?
                                                <div className='datepickerBox'>
                                                    <strong>{searchingData.start_date.getDate()}</strong>
                                                    <p>{Utility.getMonthName(searchingData.start_date.getMonth())}, {searchingData.start_date.getFullYear()} <span>Check In</span></p>
                                                </div> :
                                                <div className='datepickerBox'>
                                                    <strong>{new Date().getDate()}</strong>
                                                    <p>{Utility.getMonthName(new Date().getMonth())}, {new Date().getFullYear()} <span>Check In</span></p>
                                                </div>}
                                            {searchingData.end_date != null ?
                                                <div className='datepickerBox'>
                                                    <strong>{searchingData.end_date.getDate()}</strong>
                                                    <p>{Utility.getMonthName(searchingData.end_date.getMonth())}, {searchingData.end_date.getFullYear()} <span>Check Out</span></p>
                                                </div> :
                                                <div className='datepickerBox'>
                                                    <strong>{(new Date().getDate() + 1)}</strong>
                                                    <p>{Utility.getMonthName(new Date(new Date().getTime() + 24 * 60 * 60 * 1000).getMonth())}, {new Date(new Date().getTime() + 24 * 60 * 60 * 1000).getFullYear()} <span>Check Out</span></p>
                                                </div>}
                                        </div>
                                        <div className={searchingDataError.start_date == "Required field" || searchingDataError.end_date == "Required field" ? 'search-panel-slider-box choosedateSearch' : 'search-panel-slider-box choosedateSearch'}>
                                            <ErrorBoundary title="CommonDateTimePicker Error" >
                                                {/* <img className="ico ico-date fixedIco" src={require('../../../../Utility/Public/images/calendar-outline1.png')} /> */}
                                                <CommonDateTimePicker
                                                    dateRange={true}
                                                    selected={searchingData.start_date}
                                                    onChange={(e) => handelChangeSearch(e, 'date')}
                                                    onBlur={handleBlur}
                                                    startDate={searchingData.start_date}
                                                    endDate={searchingData.end_date}
                                                    selectsRange={true}
                                                    isClearable={true}
                                                    placeholderText="Choose date"
                                                    minDate={new Date()}
                                                    maxDate={searchingData.start_date ? endDateMinMax.maxDate : new Date(new Date().getFullYear() + 1, new Date().getMonth(), new Date().getDate() + 1)}
                                                    dateFormat={!searchingData.end_date ? "E d MMM" : "E d MMM"}
                                                    placement="bottom"
                                                />
                                            </ErrorBoundary>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={props.trendingDestinationData && props.trendingDestinationData.location != "" ? "col-sm-3 paddingL8 poPSec" : "col-sm-3 paddingL8 mTop10"}>
                                <div className='row'>

                                    <OverlayTrigger
                                        rootClose={true}
                                        trigger="click"
                                        placement="bottom"
                                        show={showOverlay}
                                        onToggle={handleOverlayToggle}
                                        onExited={handlePopoverExited}
                                        overlay={
                                            <Popover className='popover_action_inner childAdultsBox'>
                                                <Popover.Body>
                                                    <div className="popover_action_row">
                                                        <ul>
                                                            <li key="adult" className="guest-row-item">
                                                                <div className='left-row-box'>
                                                                    <div className="guest-info">
                                                                        <span className="guest-icon">
                                                                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="8" r="4" /><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" /></svg>
                                                                        </span>
                                                                        <span className="guest-label-group">
                                                                            <span className="guest-main-label">{Number(searchingData.adult) <= 1 ? 'Adult' : 'Adults'}</span>
                                                                            {/* <span className="guest-sub-label">Ages 13 or above</span> */}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className='right-row-box'>
                                                                    <div className="input-group guest-counter">
                                                                        <button className={searchingData.adult == 1 ? "counter-btn disabled" : "counter-btn"} type="button" onClick={(e) => handelChangeSearch(e, 'adult-dec')} disabled={searchingData.adult == 1}>−</button>
                                                                        <span className="counter-value">{searchingData.adult}</span>
                                                                        <button className="counter-btn" type="button" onClick={(e) => handelChangeSearch(e, 'adult-inc')}>+</button>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li key="child" className="guest-row-item">
                                                                <div className='left-row-box'>
                                                                    <div className="guest-info">
                                                                        <span className="guest-icon">
                                                                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="7" r="3" /><path d="M6 21v-1a6 6 0 0 1 12 0v1" /><path d="M12 10v4" /></svg>
                                                                        </span>
                                                                        <span className="guest-label-group">
                                                                            <span className="guest-main-label">{Number(searchingData.children) <= 1 ? 'Child' : 'Children'}</span>
                                                                            {/* <span className="guest-sub-label">Ages 2–12</span> */}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className='right-row-box'>
                                                                    <div className="input-group guest-counter">
                                                                        <button className={searchingData.children == 0 ? "counter-btn disabled" : "counter-btn"} type="button" onClick={(e) => handelChangeSearch(e, 'child-dec')} disabled={searchingData.children == 0}>−</button>
                                                                        <span className="counter-value">{searchingData.children}</span>
                                                                        <button className="counter-btn" type="button" onClick={(e) => handelChangeSearch(e, 'child-inc')}>+</button>
                                                                    </div>
                                                                </div>
                                                            </li>

                                                            <li className='childrenAgeee' key="childrenAge">
                                                                {/* {childAgeDropdownUi()} */}
                                                            </li>
                                                        </ul>
                                                        {/* <div className="children-free-note">
                                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                                                            <span>Children under 2 stay free</span>
                                                        </div> */}
                                                    </div>
                                                </Popover.Body>
                                            </Popover>
                                        }
                                    >
                                        <div className='search-panel-slider-box'>
                                            <img className="ico" src={require('../../../../Utility/Public/images/people-outline1.png')} />
                                            <h5>Guests</h5>
                                            <span className="input_field_inner ">
                                                <button className='input__fields_property'>{adultChildPlaceHolderText} </button>
                                                <i className="fa fa-angle-down down-arrow" aria-hidden="true"></i>
                                            </span>
                                        </div>
                                    </OverlayTrigger>
                                </div>

                            </div>
                            <div className='col-sm-1 paddingR8 submitButton'>
                                <div className='row'>
                                    <div className='search-panel-slider-box'>
                                        <button type="button" className={`search-btn ${isSearchDisabled ? "disabled-button" : ""}`} disabled={isSearchDisabled} onClick={() => {
                                            // setSearchSubmitted(true);
                                            // if (validSearchData()) { 
                                            dispatchSearchData();
                                            // }
                                        }}><i className="fa fa-search" aria-hidden="true"></i> <span>Search</span></button>
                                    </div>
                                </div>
                            </div>
                            <div className='col-sm-1 paddingR8 cancelModifyButton'>
                                <div className='row'>
                                    <div className='search-panel-slider-box'>
                                        <button className='cancelModifyBtn' onClick={() => { clearLocationAndDates() }}>Cancel / Modify</button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {/* Quotation Request Modal for Flights, Trains, Cabs & Customized Tour */}
            <QuotationRequestModal
                show={isQuotationModalOpen}
                onHide={() => setIsQuotationModalOpen(false)}
                initialServiceType={quotationModalType}
                serviceCategory={quotationModalType === 'cabs' ? 'cabs' : quotationModalType === 'customized_tour' ? 'customized_tour' : 'flight_train'}
            />
        </>
    );
}

SearchPanel.defaultProps = {
    searchFromHomePageFn: () => { },
    callFrom: "",
    onDateChange: () => { }
}

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        userSearchDataFromReducer: globalState.mainReducerData.userSearchData,
        userSearchErrorDataFromReducer: globalState.mainReducerData.userSearchDataError,
        trendingDestinationData: globalState.mainReducerData.trendingDestination,
        userHotelGroupPackageSelectedData: globalState.mainReducerData.hotelGroupPackageSelectedData,
        userGroupTourPackageSearchData: globalState.mainReducerData.groupTourPackageSearchData,
    };
}


export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse, setUserCredentials, logOutApp, roleWisePermission, userSearchData, setToken, userSearchDataError, trendingDestination, hotelGroupPackageSelectedData, groupTourPackageSearchData })(SearchPanel);
